import React from "react";
import CheckIcon from "../../../icons/CheckIcon";
export default function PDAvailableServicesCard() {
  const services = [
    "Document Analysis",
    "Document Writing",
    "Price Analysis",
    "Client Profiling",
    "Bridge Financing",
    "Mortgage Financing",
    "Unsecured Lending",
    "Acquiring of Property",
    "Wealth Management",
    "Identification of Property",
    "Disposal of Property",
  ];
  return (
    <div className="clip-path-bottomRightPostProperty bg-brand-lightBlue p-[14px] lg:px-8 mt-14">
      <div className="clip-path-bottomRightPostProperty  bg-white p-3 lg:p-7">
        <h3 className="mt-4 font-openSans text-brand-textBlack">
          Services available for property
        </h3>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-y-6 gap-x-5 mt-5 pr-3">
          {services.map((item, index) => {
            return (
              <div key={index} className="flex items-center">
                <CheckIcon width={14} height={14} />
                <p className="pl-1 text-xs font-openSans text-brand-textGrey">
                  {item}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
